import { useState } from 'react';
import { isMobile } from 'react-device-detect'
import { addressGenerator } from '../../../helpers/addressGenerator';
import { useWidgetContext } from '../../../context/WidgetContext';
import { TagButton } from '../button/TagButton'
import { SocialShareModal } from '../../share/SocialShareModal';

export const AgentTagActions = () => {
  const { agent } = useWidgetContext();
  const address = addressGenerator(agent.address)
  const [isSocialMediaModalOpen, setIsSocialMediaModalOpen] = useState(false)

	const onShare = () => {
		if (navigator.share && isMobile) {
			navigator
				.share({
					title: document.title,
					url: window.location.href,
				})
				.then(() => {
          // TBD what to do when share successfully
          console.log('Shared Successfully');
				})
				.catch(console.error)
		} else {
      setIsSocialMediaModalOpen(true)
    }
	}

  return (
    <div className='osirus-agent-tag-actions'>
      {address && (
        <TagButton 
          iconName='location-dot' 
          label='Directions'
          isLink
          href={
            `http://maps.google.com/maps?q=${encodeURIComponent(
              address
            )}`
          }
          target='_blank'
          rel='noreferrer'
        />
      )}
      {agent.phoneNumber && (
        <TagButton
          iconName='phone'
          label='Call'
          isLink
          href={`tel:${agent.phoneNumber}`}
          needProtocol={false}
        />
      )}
      { agent.email && (
        <TagButton 
          iconName='envelope'
          label='Email'
          isLink
          href={`mailto:${agent.email}`}
          needProtocol={false}
        />
      )}
      <TagButton
        iconName='share-nodes'
        label='Share'
        isLink={false}
        onClick={onShare}
      />
      {isSocialMediaModalOpen && (
        <SocialShareModal
          onClose={() => setIsSocialMediaModalOpen(false)}
        />
      )}
    </div>
  )
}
